<template>
  <div class="bg-white">
    <el-form :model="noticeForm" :rules="rules" ref="noticeForm" label-width="100px" class="demo-noticeForm">
      <el-form-item label="通知标题" prop="title">
        <el-input v-model="noticeForm.title" placeholder="请输入通知标题"></el-input>
      </el-form-item>
      <el-form-item label="通知文本" prop="content">
        <VueUditorWrap v-model="noticeForm.content" :config="myConfig"></VueUditorWrap>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="submit-btn" @click="submitForm('noticeForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import VueUditorWrap from 'vue-ueditor-wrap'
import {bdEditConfig} from "@/utils/utils";
import {noticeAdd,noticeDetail} from "@/api/notice";

export default {
  name: "notice-edit",
  data() {
    return {
      id: '',
      noticeForm: {
        title: '',
        content: '',
      },
      rules: {
        title: [
          {required: true, message: '请输入通知标题', trigger: 'blur'},
        ],
        content: [
          {required: true, message: '请输入通知文本', trigger: 'blur'},
        ],
      },
      myConfig: bdEditConfig()
    }
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.getDetail()
    }
    this.$emit("setIndex", '/home/notice', this.id ? "通知公告 / 编辑" : "通知公告 / 新增", true);
  },
  components: {
    VueUditorWrap
  },
  methods: {
    //  提交通知公告
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitNotice()
        }
      });
    },
    async submitNotice() {
      let _state = await noticeAdd(this.noticeForm.title, this.noticeForm.content, '', this.id)
      this.$message.success(_state.info)
      this.$router.go(-1)
    },
    //  获取通知公告详情
    async getDetail() {
      let _data = await noticeDetail(this.id)
      this.noticeForm = {
        title: _data.data.title,
        content: _data.data.content,
      }
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
  .submit-btn{
    width: 150px;
  }
</style>